import styled from '@emotion/styled';
import { Col, Row } from 'antd';
import React from 'react';

import whatHelpsIcon from 'src/public/img/icon-help.svg';
import thoughtsIcon from 'src/public/img/icon-thoughts.svg';
import whatDoesntHelpIcon from 'src/public/img/icon-what-doesn-t-help.svg';
import feelingsIcon from 'src/public/img/undraw-feeling-blue-4-b-7-q-copy.svg';

import { color, font, layout, mediaQueries } from 'src/shared/styles/variables';

import * as S from '../../stepComponents/styles';

const listElements = [
    { text: 'Common responses after a crisis', icon: thoughtsIcon },
    { text: 'What helps', icon: whatHelpsIcon },
    { text: 'What doesn’t help', icon: whatDoesntHelpIcon },
];

const ProgramContent = styled(Row)({
    maxWidth: layout.containerSmallerWidth,
    margin: '0 auto',
    padding: '6rem 0 0 1rem',
    [mediaQueries.lg]: {
        margin: '0 3rem',
        flex: '1 0 100%',
    },
});

const StyledList = styled('ul')({
    padding: 0,
    margin: 0,
});

const StyledListElement = styled('li')(
    {
        display: 'flex',
        lineHeight: 1.2,
        alignItems: 'center',
        color: color.tundora,
        '&:not(:last-child)': {
            marginBottom: '1rem',
        },
    },
    font.book(font.size.base),
);

interface StyledIconProps {
    iconUrl: string;
}

const StyledIcon = styled('i')<StyledIconProps>(({ iconUrl }) => ({
    marginRight: '1rem',
    display: 'inline-block',
    backgroundImage: `url('${iconUrl}')`,
    width: '2rem',
    height: '2rem',
    backgroundSize: 'contain',
    backgroundPositionX: 'center',
}));

const SourceInfo = styled('p')(
    {
        color: color.baliHai,
        marginTop: '5rem',
    },
    font.heavy(font.size.base),
);

const SourceLink = styled('a')({
    color: 'inherit',
    '&:hover': {
        color: color.scooter,
        textDecoration: 'underline',
    },
});

export const ProgramOverviewStep: React.SFC = () => (
    <ProgramContent>
        <Col md={14}>
            <S.StepHeading>Overview of the Course</S.StepHeading>
            <S.StepDescription small>
                Experiencing distress after a stressful or traumatic event is common. The goals of
                this short course are to help you cope and recover. We’ll cover:
            </S.StepDescription>
            <StyledList>
                {listElements.map(element => (
                    <StyledListElement key={element.icon}>
                        <StyledIcon iconUrl={element.icon} />
                        {element.text}
                    </StyledListElement>
                ))}
            </StyledList>
            <SourceInfo>
                Adapted from materials by the National Center for PTSD{' '}
                <SourceLink href="https://www.ptsd.va.gov/" target="_blank()">
                    www.PTSD.va.gov
                </SourceLink>
            </SourceInfo>
        </Col>
        <Col md={10}>
            <S.StepIcon iconUrl={feelingsIcon} />
        </Col>
    </ProgramContent>
);
